import { render } from "./BaseCard.vue?vue&type=template&id=2e4e71a7&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=2e4e71a7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4e71a7"]])

export default __exports__